import { Loader2 } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/shared/ui/alert-dialog";
import { TaxListItem } from "./utils";

interface TaxDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tax: TaxListItem | null;
  onConfirm: () => Promise<void>;
  isDeleting?: boolean;
}

export function TaxDeleteDialog({
  open,
  onOpenChange,
  tax,
  onConfirm,
  isDeleting = false,
}: TaxDeleteDialogProps) {
  const title = tax?.kind === "existing" ? "Remover taxa?" : "Remover taxa pendente?";
  const description =
    tax?.kind === "existing"
      ? "Essa ação é irreversível. A taxa será removida definitivamente do recebível."
      : "Essa taxa será removida da lista e não será enviada.";

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Removendo...
              </>
            ) : (
              "Remover"
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

